import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const COLLECTIONS_WAITING_FOR_PUBLISH_QUERY_KEY = [
  "collectionsWaitingForPublish",
];

export const useNumberOfCollectionsWaitingForPublish = () => {
  return useQuery<number>({
    queryKey: COLLECTIONS_WAITING_FOR_PUBLISH_QUERY_KEY,
    queryFn: async () => {
      return adminApiClient.getNumberOfCollectionsWaitingForPublish();
    },
  });
};
